module.exports = __webpack_public_path__ + "static/media/8_r_Layer8_67.97_3.06.96fc428e.png";